let tail: Promise<unknown> = Promise.resolve();

// One ffmpeg.wasm module, one virtual filesystem. Concurrent exec calls
// share input.mp4 and output.m4a and overwrite each other.
export const runExclusiveFfmpeg = <T>(work: () => Promise<T>): Promise<T> => {
  const run = tail.then(work, work);
  tail = run.then(
    () => undefined,
    () => undefined,
  );
  return run;
};
